
import AppEventsIndex from "./event.vue";
import AppEventsList from "./list/list.vue";
import AppEventsItem from "./item/item.vue";

const routes = [
  {
    path: "events",
    component: AppEventsIndex,
    meta: {
      auth: {
        roles: "event.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "event.index",
        component: AppEventsList,
        meta: {
          auth: {
            roles: "event.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "event.create",
        component: AppEventsItem,
        meta: {
          auth: {
            roles: "event.create",
            redirect: { name: "event.index" }
          }
        }
      },
      {
        path: ":id",
        name: "event.edit",
        component: AppEventsItem,
        meta: {
          auth: {
            roles: "event.update",
            redirect: { name: "event.index" }
          }
        }
      }
    ]
  }
];

export default routes;
